import { type User } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { type UpdateMeInput } from "../endpoints";
import { queryKeys } from "../queryKeys";

/** Self-service profile update. Only `company` is editable, and only by
 * admins (backend returns 403 otherwise — surface that to the user). */
export function useUpdateMe(): UseMutationResult<User, Error, UpdateMeInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input) => client.updateMe(input),
    onSuccess: (user) => {
      qc.setQueryData(queryKeys.me(), user);
      // The user directory shows `company` per row, so refresh too.
      qc.invalidateQueries({ queryKey: ["users"] });
    },
  });
}
